export const environment = {
    production: true,
    apiBaseUrl: "https://development.fixz.co.uk/api"
};
